import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useBooks } from '../context/BooksContext';
import { useLibrary } from '../context/LibraryContext';
import { IoBook } from 'react-icons/io5';
import './Recommendations.css';

export default function Recommendations({ currentBookId }) {
  const { books } = useBooks();
  const { library } = useLibrary();
  const navigate = useNavigate();

  const recommendations = useMemo(() => {
    const currentBook = books.find(b => b.id === currentBookId);
    if (!currentBook) return [];

    const libraryIds = library.map(b => b.id);

    return books
      .filter(b => b.id !== currentBookId)
      .map(book => {
        let score = 0;

        // Même genre = +3
        if (book.genre === currentBook.genre) score += 3;

        // Tags en commun
        if (book.tags && currentBook.tags) {
          const common = book.tags.filter(t => currentBook.tags.includes(t));
          score += common.length * 2;
        }

        // Populaire
        score += Math.min(book.likes / 1000, 2);

        // Pas déjà dans la biblio = bonus
        if (!libraryIds.includes(book.id)) score += 1;

        return { ...book, score };
      })
      .filter(b => b.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 4);
  }, [books, currentBookId, library]);

  if (recommendations.length === 0) return null;

  return (
    <div className="reco-section">
      <h3 className="reco-title">📖 Si tu as aimé, tu aimeras aussi</h3>
      <div className="reco-scroll">
        {recommendations.map((book, i) => (
          <motion.div
            key={book.id}
            className="reco-card"
            onClick={() => navigate('/read/' + book.id)}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.1 }}
            whileHover={{ y: -3 }}
          >
            <div className="reco-cover" style={{
              background: book.coverImage ? `url(${book.coverImage}) center/cover no-repeat` : book.coverGradient
            }}>
              <IoBook style={{ color: 'white', fontSize: 20, opacity: 0.5 }} />
            </div>
            <h4 className="reco-card-title">{book.title}</h4>
            <p className="reco-card-author">{book.author}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}